import { SectionHeading } from "../common/SectionHeading";
import { Reveal } from "../common/Reveal";
import { EmailCapture } from "../common/EmailCapture";
import { IMAGES } from "../../lib/data";

const TEASERS = ["Slushies", "Snow Cones", "More Ways To Bring The Show"];

export const ComingSoon = () => (
    <section data-testid="coming-soon-section" className="bg-ink tent-stripes text-white py-24 md:py-32 overflow-hidden">
        <div className="mx-auto max-w-[1440px] px-5 md:px-10">
            <div className="grid gap-14 lg:grid-cols-2 items-center">
                <div>
                    <SectionHeading
                        chapter="09"
                        kicker="Next Act"
                        title="Coming Soon"
                        copy="New machines. New treats. New ways to bring the show. Join the list and hear it first."
                        dark
                        testid="coming-soon-heading"
                    />
                    <ul className="space-y-2 mb-10" data-testid="coming-soon-list">
                        {TEASERS.map((t, i) => (
                            <Reveal key={t} delay={i * 0.08}>
                                <li className="font-oswald uppercase leading-[0.95] text-4xl md:text-6xl text-stroke-pink hover:text-pink transition-colors duration-500 cursor-default">
                                    {t}
                                </li>
                            </Reveal>
                        ))}
                    </ul>
                    <EmailCapture source="coming_soon" dark testid="coming-soon-notify" />
                </div>
                <Reveal delay={0.15}>
                    <div className="relative">
                        <div className="rounded-[2.5rem] overflow-hidden rotate-2 border-4 border-pink/40">
                            <img src={IMAGES.slushie} alt="Slushie teaser" loading="lazy" className="w-full aspect-[4/5] object-cover" />
                        </div>
                        <span className="absolute -top-4 -right-2 rotate-6 rounded-full bg-pink px-6 py-3 font-oswald uppercase tracking-[0.25em] text-xs text-ink shadow-xl">
                            Ice Cold Soon
                        </span>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
